module.exports = __webpack_public_path__ + "static/media/dewpoint.ba116f92.svg";